import { Datepicker } from 'vanillajs-datepicker';
import fr from 'vanillajs-datepicker/locales/fr';

Object.assign(Datepicker.locales, fr);

export default function() {
    document.querySelectorAll('.datepicker-input').forEach(function( element ) {
    	const datepicker = new Datepicker( element, {
    		language: 'fr',
    		maxDate: element.getAttribute('max') ? element.getAttribute('max') : null,
            minDate: element.getAttribute('min') ? element.getAttribute('min') : null,
            readonly: true,
            maxView: 3,
            startView: 3
    	})
    })
}
